import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-add-template-dialog',
  templateUrl: './add-template-dialog.component.html',
  styleUrls: ['./add-template-dialog.component.scss']
})
export class AddTemplateDialogComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  constructor() {

  }

  ngOnInit() {

  }
  ngAfterViewInit (): void {
  }
  onOkClicked(): boolean {
    if (!this.data.input.name || this.data.input.name.length === 0) {
      return false;
    }
    return true;
  }
}
